import type { Contact } from './useContacts'

export function exportContactsToCsv(contacts: Contact[]) {
  const headers = [
    'name', 'email', 'phone', 'address', 'helium_wallet', 'btc_wallet',
    'eth_wallet', 'usdt_wallet', 'usdc_wallet', 'iban', 'paypal',
    'payment_method', 'currency', 'monthly_report', 'tag_list', 'notes'
  ]

  const rows = contacts.map(c => [
    c.name || '',
    c.email || '',
    c.phone || '',
    c.address || '',
    c.helium_wallet || '',
    c.btc_wallet || '',
    c.eth_wallet || '',
    c.usdt_wallet || '',
    c.usdc_wallet || '',
    c.iban || '',
    c.paypal || '',
    c.payment_method || '',
    c.currency || '',
    c.monthly_report ? 'true' : 'false',
    c.tag_list || '',
    c.notes || ''
  ].map(val => {
    const stringVal = String(val)
    if (stringVal.includes(',') || stringVal.includes('"') || stringVal.includes('\n')) {
      return `"${stringVal.replace(/"/g, '""')}"`
    }
    return stringVal
  }).join(','))

  const csvContent = [headers.join(','), ...rows].join('\n')

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.setAttribute('href', url)
  link.setAttribute('download', 'contacts_export.csv')
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}
